import { Button } from '@mui/material'

const IconBtn = ({
  icon, onClick, customStyle, ...props
}) => (
  <Button sx={[styles.root, customStyle]} onClick={onClick} {...props}>
    {icon}
  </Button>
)

const styles = {
  root: {
    width: { xs: '35px', sm: '30px' },
    height: { xs: '35px', sm: '30px' },
    minWidth: 'unset',
    backgroundColor: '#f9f9f9',
    color: '#c1c1c1',
    borderRadius: '10px',
    '& svg': {
      fontSize: { xs: '14px', sm: '18px' },
    },
  },
}

export default IconBtn
